module.exports = "<div class=\"home-content\">\r\n  <h1>Bienvenue sur CallManager.</h1>\r\n</div>\r\n"